/**
 * Upload limits shared by every CAD-import entry point (new project, import
 * part into an existing project, assistant-chat attachments).
 *
 * Kept in one place because the limit is enforced in several disconnected
 * spots — reactive-form validators, dropzone config and the desktop file
 * dialog — and they must not drift.
 *
 * Meshes (STL/PLY) are far larger than the equivalent STEP: a scan-derived or
 * heavily tessellated part routinely runs to several hundred MB, so the cap is
 * sized for those rather than for BREP files.
 *
 * S3 accepts up to 5GB in a single PUT, so this ceiling is a product decision,
 * not a storage one. Anything raised beyond it must also revisit the
 * presigned-URL lifetime in the backend (`preUpload`), which has to outlast the
 * slowest upload we are willing to support.
 */
export const MAX_CAD_UPLOAD_MB = 1024;

export const MAX_CAD_UPLOAD_BYTES = MAX_CAD_UPLOAD_MB * 1024 * 1024;
